var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('upload-cropper',{attrs:{"limit":3,"limitSize":1024,"on-change":_vm.handleOnChange,"http-request":_vm.handleHttpRequest,"on-success":_vm.handleSuccess,"on-error":_vm.handleError,"on-remove":_vm.handleRemove,"fileList":_vm.fileList1,"cropper":{
      height: 300,
      autoCrop: true,
      autoCropWidth: 300,
      autoCropHeight: 200,
      fixed: true,
      fixedNumber: [3, 2]
    }}}),_vm._v(" "),_c('el-button',{staticStyle:{"margin-top":"10px"},on:{"click":function($event){}}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{staticStyle:{"margin-top":"10px"},attrs:{"type":"primary"},on:{"click":function($event){_vm.postForm()}}},[_vm._v("上传")]),_vm._v(" "),_c('el-button',{staticStyle:{"margin-top":"10px"},attrs:{"type":"primary"},on:{"click":function($event){_vm.getUploadData()}}},[_vm._v("console.log(表单数据)")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36725ddd","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 121
// module chunks = 0